import React from 'react';

import PropTypes from 'prop-types';

import { defaultTemplate } from 'core/hoc';
import { ListLayout } from 'core/layouts';

function ApplicationListLayoutTemplate({ store, children }) {
    const {
        routes,
        tableStore,
        authorization
    } = store;
    const loaderStore = tableStore.loaderStore;

    return (
        <ListLayout onCreate={routes.create} onCreateCsv={routes.createCsv} authorization={authorization} loading={loaderStore.initial && loaderStore.loading} >
            {children}
        </ListLayout>
    )
}

ApplicationListLayoutTemplate.propTypes = {
    store: PropTypes.object,
    children: PropTypes.any
};

export default defaultTemplate(ApplicationListLayoutTemplate);
